export const IS_LOADING = "IS_LOADING";
export const GET_BOOKMARK_LIST = "GET_BOOKMARK_LIST";
export const TOP_TEN_LIKED_BOOKMARKS = "TOP_TEN_LIKED_BOOKMARKS";
export const GET_ACTIVE_BOOKMARK_SITES = "GET_ACTIVE_BOOKMARK_SITES";
